
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MbscModule } from '@mobiscroll/angular';
import { categoryData, operatingTimeData, statusData, taskType } from '../../../../interfaces/selectData';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { FormsModule } from '@angular/forms';
import { EventFilterService } from '../../../../services/shared/filter/event-filter.service';
import { getPopupButtonsEventFilter, popupOptions, sliderOptions } from '../../../../interfaces/popup-buttons/filter/popup-options';

@Component({
  selector: 'app-filter-event-popup',
  imports: [MbscModule, FormsModule, NgxSliderModule],
  templateUrl: './filter-event-popup.component.html',
  styleUrl: './filter-event-popup.component.scss'
})
export class FilterEventPopupComponent {
  @ViewChild('eventFilterButton', { static: false }) eventFilterButton!: ElementRef;
  @ViewChild('eventFilterPopup', { static: false }) eventFilterPopup: any;

  @Input() listEvents: any[] = [];
  @Input() originalEvents: any[] = [];
  @Output() filteredEventChange = new EventEmitter<any[]>();

  popupAnchorEventFilter: HTMLElement | null = null;

  searchTitle: string = '';
  searchLocation: string = '';
  searchCustomer: string = '';
  searchStatus: any;
  searchCategory: any;
  searchOperatingTime: any;
  searchTaskType: any;
  searchOnline: any;
  searchStartTime: any;
  searchEndTime: any;

  statusData = statusData;
  categoryData = categoryData;
  operatingTimeData = operatingTimeData;
  taskType = taskType;

  minDuration: number = 1;
  maxDuration: number = 15;

  filter: any;
  filteredEvents: any[] | null = null;

  public popupOptions = popupOptions;
  public sliderOptions = sliderOptions;
  popupButtonsEventFilter = getPopupButtonsEventFilter(() => this.resetFilter());

  constructor(private eventFilterService: EventFilterService) {}

  openEventFilter(popupAnchor: any) {
    this.popupAnchorEventFilter = popupAnchor;
    this.eventFilterPopup.open();
  }

  resetFilter() {
    this.searchTitle = '';
    this.searchLocation = '';
    this.searchStatus = [];
    this.searchCategory = [];
    this.searchOperatingTime = [];
    this.searchTaskType = [];
    this.searchOnline = false;
    this.searchStartTime = undefined;
    this.searchEndTime = undefined;
    this.minDuration = 1;
    this.maxDuration = 15;
  
    this.filteredEventChange.emit([]);
  }
  
  applyBacklogFilter() {
    if (!this.originalEvents || this.originalEvents.length === 0) {
      return;
    }
  
    this.filter = {
      searchTitle: this.searchTitle,
      searchLocation: this.searchLocation,
      searchStatus: this.searchStatus || [],
      searchCategory: this.searchCategory || [],
      searchOperatingTime: this.searchOperatingTime || [],
      searchTaskType: this.searchTaskType || [],
      searchOnline: this.searchOnline,
      searchStartTime: this.searchStartTime,
      searchEndTime: this.searchEndTime,
      minDuration: this.minDuration,
      maxDuration: this.maxDuration
    };
  
    this.filteredEvents = this.eventFilterService.filterTasks(this.originalEvents, this.filter);
    console.log('Gefilterte Events:', this.filteredEvents);
    this.filteredEventChange.emit(this.filteredEvents);
  }
  
}
